import { render, staticRenderFns } from "./SafetyConfirmRegister.vue?vue&type=template&id=a6dcf5ca&scoped=true&lang=pug"
import script from "./SafetyConfirmRegister.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmRegister.vue?vue&type=script&lang=ts"
import style0 from "./SafetyConfirmRegister.vue?vue&type=style&index=0&id=a6dcf5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dcf5ca",
  null
  
)

export default component.exports